import { TravailStubPage } from '../../../../components/parcours/TravailStubPage';
import { getTravailStub } from '../../../../config/travaux-particuliers';

export default function ChauffeEauThermodynamiquePage() {
  const travail = getTravailStub('chauffe-eau-thermodynamique');
  if (!travail) return null;
  return <TravailStubPage travail={travail} />;
}
